import { useEffect, useState, useRef } from 'react'
import './App.css'
import Layout from './components/layout/layout';
import { Outlet, useLocation } from 'react-router-dom';
import https from './service/httpsService';
import { AppToaster } from './components/notifications/AppToaster';
import type { PermissionsObject } from './components/layout/types/globalTypes';

const normalizePath = (rawUrl?: string | null) => {
    const trimmedUrl = rawUrl?.trim();

    if (!trimmedUrl || trimmedUrl.startsWith("#")) return "";

    try {
        const url = new URL(trimmedUrl, window.location.origin);
        return url.pathname.toLowerCase().replace(/\/+$/, "") || "/";
    } catch {
        return trimmedUrl.split("?")[0].toLowerCase().replace(/^\/?/, "/").replace(/\/+$/, "") || "/";
    }
};

const getRouteTitle = (pathname: string, permissions?: Record<string, PermissionsObject>) => {
    const currentPath = normalizePath(pathname);
    const matchingPermission = (Object.values(permissions ?? {}) as PermissionsObject[])
        .filter(permission => permission.displayName && normalizePath(permission.url))
        .sort((a, b) => normalizePath(b.url).length - normalizePath(a.url).length)
        .find(permission => {
            const permissionPath = normalizePath(permission.url);
            return currentPath === permissionPath || currentPath.startsWith(`${permissionPath}/`);
        });

    return matchingPermission?.displayName;
};

const App = () => {
    const dataFetch = useRef(false)
    const location = useLocation();

    const [count, setCount] = useState(null);
    const [data, setData] = useState<any>(null);

    useEffect(() => {
        const routeTitle = getRouteTitle(location.pathname, data?.permissions);

        if (routeTitle) {
            document.title = routeTitle;
        }
    }, [location.pathname, data?.permissions]);

    useEffect(() => {
        if (dataFetch.current) return;

        dataFetch.current = true

        https.get("api/v1/Account/Permissions").then((response) => {
            return response.data
        })
            .then((data) => {
                setData(data);
                window.localStorage.setItem('userData', JSON.stringify(data))
            }).catch((reason) => {
                console.log(reason)
            })
    }, []);

    return (
        <Layout data={data}>
            <Outlet />
            <AppToaster />
        </Layout>
    )
};

export default App
